export default "__VITE_ASSET__BAZA4oM0__"